import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { toast } from 'sonner';
import { Zap, Loader2 } from 'lucide-react';

const AuthCallback = () => {
  const navigate = useNavigate();
  const { exchangeSession } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    // Prevent double processing in StrictMode
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processAuth = async () => {
      try {
        // Extract session_id from URL fragment
        const hash = window.location.hash;
        const params = new URLSearchParams(hash.substring(1));
        const sessionId = params.get('session_id');

        if (!sessionId) {
          toast.error('Authentication failed - no session ID');
          navigate('/login');
          return;
        }

        // Exchange session_id for user data
        const user = await exchangeSession(sessionId);
        
        toast.success(`Welcome to Sub-Zero, ${user.name}!`);
        
        // Navigate to dashboard with user data to skip auth check
        navigate('/dashboard', { state: { user }, replace: true });
      } catch (error) {
        console.error('Auth callback error:', error);
        toast.error('Authentication failed. Please try again.');
        navigate('/login');
      }
    };

    processAuth();
  }, [exchangeSession, navigate]);

  return (
    <div className="min-h-screen bg-background flex items-center justify-center">
      <div className="text-center">
        <div className="w-16 h-16 bg-primary/10 border border-primary/30 rounded-sm flex items-center justify-center mx-auto mb-6">
          <Zap className="w-8 h-8 text-primary animate-pulse" />
        </div>
        <Loader2 className="w-8 h-8 text-primary animate-spin mx-auto mb-4" />
        <p className="text-muted-foreground font-mono text-sm uppercase tracking-widest">
          AUTHENTICATING...
        </p>
        <p className="text-muted-foreground/60 text-xs mt-2">
          Establishing secure connection
        </p>
      </div>
    </div>
  );
};

export default AuthCallback;
